import { createFileRoute } from '@tanstack/react-router';
import { Content } from '@/components/ui/content';
import { CopyText } from '@/components/ui/copy-text';
import { ContentLoader } from '@/components/ui/loaders';
import { useRouter } from '@/hooks/use-router';
import { meta } from '@/lib/meta';
import { useDynamicDetail, useDynamicList } from '@/services/dynamic-resource';
import { SaleQuickView } from '../+components/sale-quick-view';

export const Route = createFileRoute('/_app/sales/$id/view')({
  head: () => meta({ label: 'Pedido' }),
  component: RouteComponent,
});

function RouteComponent() {
  const { push } = useRouter();
  const { id } = Route.useParams();
  const { data: sale, isLoading, isError, refetch } = useDynamicDetail('sales', id);
  const { data: itemsResponse } = useDynamicList('sale-items', {
    saleId: id,
    perPage: 100,
  });

  const items = (itemsResponse?.data ?? []).filter((item: any) => item.saleId === id);
  const shortId = id?.slice(0, 8);

  if (isError) {
    return (
      <Content
        breadcrumbs={{ title: 'Pedido', items: [{ label: 'Listagem', route: '/sales' }] }}
      >
        <div className="flex flex-col items-center gap-3 py-16 text-center">
          <p className="text-muted-foreground">Não foi possível carregar este pedido.</p>
          <button
            type="button"
            className="text-primary underline"
            onClick={() => refetch()}
          >
            Tentar novamente
          </button>
        </div>
      </Content>
    );
  }

  if (!sale) return <ContentLoader show={isLoading} />;

  return (
    <Content
      breadcrumbs={{
        title: (
          <>
            Pedido {sale.saleNumber ?? ''}{' '}
            <CopyText className="ml-2" value={id} label={`${shortId}...`} />
          </>
        ),
        items: [
          { label: 'Listagem', route: '/sales' },
          { label: 'Visualizar', active: true },
        ],
      }}
    >
      <div className="w-full overflow-hidden rounded-[18px] border border-border-strong bg-card">
        <SaleQuickView
          standalone
          sale={sale}
          items={items}
          onEdit={() => push(`/sales/${id}`)}
        />
      </div>
    </Content>
  );
}
